<style scoped>
.br-10 {
  padding: 10px;
  border-radius: 10px;
}
</style>

<template>
  <v-layout fill-height justify-center class="pa-2">
    <v-form @submit.prevent="submitForm($event)">
      <v-card class="br-10 text-center elevation-3">
        <v-layout class="pa-3" column wrap>
          <span class="title primary--text text--darken-2">
            <strong>{{ $t('complaint_proof') }}</strong>
          </span>
          <span class="subheading grey--text text--darken-2 text-xs-left pt-2">{{ $t('select_mode') }}:</span>
          <v-layout justify-space-between :column="$vuetify.breakpoint.xsOnly">
            <v-flex v-if="isCordova" xs12>
              <v-btn block outlined color="primary" class="black--text text" style="margin-left: 2px" dark @click="setOptionUpload({ optionUpload: 'camera' })">{{ $t('camera') }}</v-btn>
            </v-flex>
            <v-flex xs12>
              <v-btn block outlined color="primary" class="black--text text" style="margin-left: 2px" dark @click="setOptionUpload({ optionUpload: 'attachment' })">{{ $t('attachment') }}</v-btn>
            </v-flex>
           </v-layout>
            <!-- <v-layout row wrap class="pt-2" v-if="optionUpload === 'camera'">
              <v-flex xs12 class="pa-2" @click="startCameraAbove()">
                <v-card id="cameraBox" dark color="grey lighten-2" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 elevation-0" v-if="!camera">
                  <v-card-text class="px-0">
                    <v-icon v-if="!imgsrc" style="font-size: 48px;" color="grey">fa-camera</v-icon><br>
                    <span class="black--text font-weight-medium">{{ $t('attach_image') }}</span>
                    </v-card-text>
                  <img v-if="imgsrc" :src="imgsrc" style="max-width: 80%; max-height: 60%;"/>
                </v-card>
                <v-card id="cameraBox" dark color="transparent" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 pt-3 elevation-0" v-if="camera"></v-card>
              </v-flex>
              <v-layout justify-end xs12>
                <v-btn color="primary" dark @click="takePicture()" :disabled="!camera">{{ $t('capture') }}</v-btn>
              </v-layout> -->
          <v-layout row wrap class="pt-2" v-if="optionUpload === 'camera'">
            <v-flex xs12 class="pa-2" @click="startCameraAbove()">
              <v-card id="cameraBox" dark color="grey lighten-2" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 pt-3 elevation-0" v-if="!camera">
                <v-card-text class="px-0">
                  <v-icon style="font-size: 48px;" color="grey">fa-camera</v-icon><br>
                  <span class="black--text font-weight-medium">{{ $t('attach_image') }}</span>
                  <input id="attachment" accept="image/*" name="attachment" hidden :data-vv-as="$t('attach_image')" @change="setFile({ file: $event.target.files[0] })" type="file" v-validate="file ? '' : rules.file"><br>
                  <span style="color: black">{{ file ? file.name || 'photo-' + new Date().getTime().toString() + '.jpg' : 'No Photo' }}</span>
                  <span style="color: red">{{ errors.collect('attachment') ? errors.collect('attachment')[0] : '' }}</span>
                </v-card-text>
              </v-card>
              <v-card id="cameraBox" dark color="transparent" style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;" class="br-12 pt-3 elevation-0" v-if="camera"></v-card>
            </v-flex>
            <v-layout justify-end xs12>
              <v-btn color="primary" dark @click="takePicture()" :disabled="!camera">{{ $t('capture') }}</v-btn>
            </v-layout>
          </v-layout>
          <v-layout row wrap class="pt-2" v-if="optionUpload === 'attachment'">
            <v-flex xs12 class="pa-2" @click="submitAttachment()">
              <v-card
                dark
                color="grey lighten-2"
                style="height: 180px; border: 1px solid red; outline: 2px dashed indigo;"
                class="br-12 pt-3 elevation-0"
              >
                <v-card-text class="px-0">
                  <v-icon style="font-size: 48px;" color="grey">fa-paperclip</v-icon>
                  <br>
                  <span class="black--text font-weight-bold">{{ $t('attach_image') }}</span>
                  <input
                    id="attachment"
                    name="attachment"
                    accpet="image/*"
                    hidden
                    :data-vv-as="$t('attach_image')"
                    @change="loadFile({ file: $event.target.files[0] })"
                    type="file"
                    v-validate="rules.file"
                  >
                  <br>
                  <span style="color: black">{{ file ? file.name : 'No Photo' }}</span>
                  <span
                    style="color: red"
                  >{{ errors.collect('attachment') ? errors.collect('attachment')[0] : '' }}</span>
                </v-card-text>
              </v-card>
            </v-flex>
            <span
              class="pt-2 caption primary--text font-weight-bold"
            >*Required / Perlu ada lampiran aduan*</span>
          </v-layout>
        </v-layout>
      </v-card>
      <br>
      <v-card class="br-10 text-xs-center elevation-3">
        <v-layout class="pa-3" column wrap>
              <span class="title primary--text text--darken-2">
                <strong>{{ $t('complaint_form') }}</strong>
              </span>
              <v-text-field
                prepend-icon="fa-flag fa-lg"
                :error-messages="errors.collect('subject')"
                :value="data.subject"
                @input="patchData({ subject: $event })"
                :label="$t('subject')"
                name="subject"
                required
                type="text"
                v-validate="rules.subject"
              ></v-text-field>
              <v-textarea
                prepend-icon="fa-map-marker fa-lg"
                :error-messages="errors.collect('location')"
                :data-vv-as="$t('location')"
                name="location"
                :value="data.location"
                @input="patchData({ location: $event })"
                :label="$t('location')"
                required
                type="text"
                v-validate="rules.location"
              ></v-textarea>
              <v-textarea
                prepend-icon="fa-file fa-lg"
                :error-messages="errors.collect('description')"
                :data-vv-as="$t('description')"
                :label="$t('description')"
                :value="data.description"
                @input="patchData({ description: $event })"
                name="description"
                v-validate="rules.description"
                type="text"
                required
              ></v-textarea>
              <br>
        </v-layout>
      </v-card>
      <br v-if="marker.position.lat && marker.position.lng">
      <v-alert
       :value="true"
        v-if="marker.position.lat && marker.position.lng"
        type="info"
        class="elevation-3 br-10"
      >
        {{ $t('desc_map_initial') }}
      </v-alert>
      <l-map
        v-if="marker.position.lat && marker.position.lng"
        style="z-index: 0; height: 20%;" class="elevation-3 br-10"
        :zoom="zoom"
        :center="marker.position"
        :options="{ closeOnClick: false, doubleClickZoom: false }">
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker
          :draggable="true"
          :lat-lng.sync="marker.position"
          @add="$nextTick(() => $event.target.openPopup())">
          <l-popup :options="{ closeButton: false, closeOnClick: false }">{{ $t('desc_map_complaint_here') }}</l-popup>
        </l-marker>
      </l-map>
      <div
        v-if="marker.position.lat && marker.position.lng">
      <v-alert
        v-if="marker.position.lat.toString() !== data.geolocation.coords.latitude.toString() && marker.position.lng.toString() !== data.geolocation.coords.longitude.toString()"
        :value="true"
        type="info"
        color="green"
        class="elevation-3 br-10 "
      >
        <v-layout align-center>
          <div class="column">
            <span>{{ $t('desc_mapconfirmation1') }}</span><br>
            <span class="caption">{{ $t('desc_mapconfirmation2') }}</span>
          </div>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" class="white--text" @click="setNewLocation('reset')">{{ $t('no') }}</v-btn>
          <v-btn color="primary" class="white--text" @click="setNewLocation('new')">{{ $t('yes') }}</v-btn>
        </v-layout>
      </v-alert>
      </div>
      <br>
      <v-card class="br-10 text-xs-center elevation-3">
            <v-layout class="pa-3" column wrap>
              <span class="title primary--text text--darken-2">
                <strong>{{ $t('complainant_detail') }}</strong>
              </span>
              <v-text-field
                prepend-icon="fa-user-circle fa-lg"
                :error-messages="errors.collect('full_name')"
                clearable
                :value="data.complainant.full_name"
                @input="patchComplainant({ full_name: $event })"
                :label="$t('full_name')"
                name="full_name"
                required
                type="text"
                :disabled="hasSession"
                v-validate="rules.full_name"
              ></v-text-field>
              <v-text-field
                class="pt-2"
                prepend-icon="fa-id-card fa-lg"
                :error-messages="errors.collect('ic_num')"
                clearable
                :data-vv-as="$t('ic_num')"
                :mask="'######-##-####'"
                name="ic_num"
                :value="data.complainant.ic_num"
                :counter="14"
                @input="patchComplainant({ ic_num: $event })"
                maxlength="14"
                :label="$t('ic_num')"
                required
                type="text"
                :disabled="hasSession"
                return-masked-value
                v-validate="rules.ic_no"
              ></v-text-field>
              <v-text-field
                class="pt-2"
                prepend-icon="fa-phone-square fa-lg"
                :error-messages="errors.collect('phone_no')"
                :data-vv-as="$t('phone_no')"
                :label="$t('phone_no')"
                :value="data.complainant.phone"
                @input="patchComplainant({ phone: $event })"
                name="phone_no"
                v-validate="rules.phone"
                maxlength="11"
                type="tel"
                :disabled="hasSession"
                required
              ></v-text-field>
              <v-text-field
                class="pt-2"
                prepend-icon="fa-envelope fa-lg"
                :error-messages="errors.collect('email_address')"
                :data-vv-as="$t('email_address')"
                :value="data.complainant.email"
                @input="patchComplainant({ email: $event })"
                :label="$t('email_address')"
                name="email_address"
                required
                type="email"
                :disabled="hasSession"
                v-validate="rules.email_address"
              ></v-text-field>
            </v-layout>
      </v-card>
      <v-layout justify-end mt-2>
        <v-btn
          :block="$vuetify.breakpoint.xsOnly"
          color="primary"
          type="submit"
          :disabled="isLoading"
          :loading="isLoading"
        >{{ $t('submit') }}</v-btn>
      </v-layout>
    </v-form>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { LMap, LTileLayer, LMarker, LPopup } from 'vue2-leaflet'

export default {
  beforeRouteLeave (to, from, next) {
    if (window.hasOwnProperty('cordova')) {
      CameraPreview.stopCamera()
    }
    this.resetData()
    next()
  },
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup
  },
  computed: {
    isCordova () {
      return window.hasOwnProperty('cordova')
    },
    ...mapGetters({
      hasName: 'auth/hasName',
      hasSession: 'auth/hasSession',
      isLoading: 'complaint/isLoading'
    }),
    ...mapState({
      camera: state => state.complaint.camera,
      data: state => state.complaint.data,
      optionUpload: state => state.complaint.optionUpload,
      file: state => state.complaint.file,
      rules: state => state.complaint.rules
    }),
    isValid: function () {
      return Object.keys(this.fields).every(key => this.fields[key].valid)
    }
  },
  created: async function () {
    await this.resetData()
    const fetchSession = this.$store.dispatch('auth/session')
    navigator.geolocation.getCurrentPosition(function (position) {
      const geolocation = {
        coords: {
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          altitude: position.coords.altitude,
          accuracy: position.coords.accuracy,
          altitudeAccuracy: position.coords.altitudeAccuracy,
          heading: position.coords.heading,
          speed: position.coords.speed
        },
        timestamp: position.timestamp
      }
      this.latitude = position.coords.latitude
      this.longitude = position.coords.longitude
      this.marker.position.lat = Object.assign(position.coords.latitude)
      this.marker.position.lng = Object.assign(position.coords.longitude)
      this.$store.dispatch('complaint/patchData', { geolocation })
    }.bind(this), (error) => { alert(error.message) }, { enableHighAccuracy: true })

    await fetchSession
      .then(
        function (value) {
          this.$store.commit('loading/setPageLoading', { loading: false })
          if (
            value.userCtx.name !== null &&
            value.userCtx.name !== 'couchdb@menggaris.com'
          ) {
            this.$store.dispatch('complaint/patchComplainant', {
              email: value.userCtx.name
            })
            this.$store.dispatch('complaint/patchComplainant', {
              phone: value.userCtx.phone
            })
            this.$store.dispatch('complaint/patchComplainant', {
              full_name: value.userCtx.full_name
            })
            this.$store.dispatch('complaint/patchComplainant', {
              ic_num: value.userCtx.ic_num
            })
          }
        }.bind(this)
      )
      .catch(function (error) {
        return error
      })
    if (this.isCordova) {
      window.addEventListener('scroll', this.handleScroll)
    }
    if (this.optionUpload === 'camera') {
      this.startCameraAbove()
    }
  },
  data () {
    return {
      url: 'http://{s}.tile.osm.org/{z}/{x}/{y}.png',
      zoom: 15,
      latitude: 0,
      longitude: 0,
      marker: { position: { lat: '', lng: '' } }
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    ...mapActions({
      attachFile: 'complaint/attachFile',
      patchComplainant: 'complaint/patchComplainant',
      patchData: 'complaint/patchData',
      resetData: 'complaint/resetData',
      submitData: 'complaint/submitData',
      updateData: 'complaint/updateData'
    }),
    ...mapMutations({
      setCamera: 'complaint/setCamera',
      setFile: 'complaint/setFile',
      setLocation: 'complaint/setLocation',
      setOptionUpload: 'complaint/setOptionUpload'
    }),
    loadFile ({ file }) {
      if (!file.type.startsWith(`image/`)) {
        return alert('Invalid file type')
      }
      var FileSize = file.size / 1024 / 1024
      if (FileSize > 5) {
        alert('File size exceeds 5 MB')
      } else {
        this.setFile({ file: file })
        // var output = document.getElementById('output')
        // output.src = URL.createObjectURL(file)
      }
    },
    handleScroll () {
      if (window.scrollY > 0) {
        this.stopCameraAbove()
      } else {
        if (this.file === null && this.optionUpload === 'camera') {
          this.startCameraAbove()
        }
      }
    },
    setNewLocation: function (payload) {
      if (payload === 'new') {
        this.setLocation(this.marker.position)
      } else {
        this.setLocation({
          lat: Number(this.latitude),
          lng: Number(this.longitude)
        })
        this.marker.position.lat = Number(this.latitude)
        this.marker.position.lng = Number(this.longitude)
      }
    },
    submitForm: async function ($event) {
      if (!(await this.$validator.validateAll())) return
      const response = await this.submitData()
      this.resetData()
      this.$router.push(`/complaint/detail/${response.id || response._id}?feedback=true`)
    },
    submitAttachment: async function ($event) {
      document.getElementById('attachment').click()
    },
    startCameraAbove: async function () {
      await this.setCamera({ camera: true })
      const width = document.getElementById('cameraBox').offsetWidth
      const x = document.getElementById('cameraBox').getBoundingClientRect().left
      const y = document.getElementById('cameraBox').getBoundingClientRect().top
      const cameraOption = {
        x: x,
        y: y,
        width: width,
        height: 180,
        camera: CameraPreview.CAMERA_DIRECTION.BACK,
        tapFocus: true,
        previewDrag: false,
        tapPhoto: false
      }
      CameraPreview.startCamera(cameraOption)
    },
    stopCameraAbove: function () {
      this.setCamera({ camera: false })
      CameraPreview.stopCamera()
    },
    dataURItoBlob: function (dataURI) {
      var byteString
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1])
      } else {
        byteString = unescape(dataURI.split(',')[1])
      }
      var mimeString = dataURI
        .split(',')[0]
        .split(':')[1]
        .split(';')[0]

      var ia = new Uint8Array(byteString.length)
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i)
      }

      return new Blob([ia], { type: mimeString })
    },
    takePicture: function () {
      CameraPreview.takePicture(
        { width: 640, height: 640, quality: 85 },
        function (imgData) {
          const file = this.dataURItoBlob(
            'data:image/jpeg;base64,' + imgData[0]
          )
          this.setFile({ file })
          this.setCamera({ camera: false })
          CameraPreview.stopCamera()
        }.bind(this)
      )
    }
  },
  watch: {
    optionUpload: function (value) {
      if (value === 'attachment') {
        if (window.hasOwnProperty('cordova')) {
          CameraPreview.stopCamera()
        }
      } else {
        if (this.file === null) {
          this.startCameraAbove()
        }
      }
    }
  }
}
</script>
